import {
  hasRepositoryConfirmedOwner,
  hasRepositoryProposedOwner,
} from '@internal/plugin-catalog-page-addons-react';
import React from 'react';

import { useEntity } from '@backstage/plugin-catalog-react';

import { Box } from '@material-ui/core';

import { RepositoryManageOwnership } from '../Components';

export const RepositoryActionContent = () => {
  const { entity } = useEntity();

  return (
    <Box display="flex" alignItems="center" flexWrap="wrap" gridGap={16}>
      {(hasRepositoryProposedOwner(entity) ||
        hasRepositoryConfirmedOwner(entity)) && <RepositoryManageOwnership />}
    </Box>
  );
};
